import { render, staticRenderFns } from "./commerceList.vue?vue&type=template&id=be522d36&"
import script from "./commerceList.vue?vue&type=script&lang=js&"
export * from "./commerceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports